import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { SocialFollowIconComponent } from './social-follow-icon.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule
	],
	declarations: [
		SocialFollowIconComponent
	],
	exports: [
		SocialFollowIconComponent
	]
})
export class SocialFollowIconModule { }
